import { Form } from 'react-final-form';

import { valueSetterMutator } from 'src/app/shared/form/mutators';

import { CategoryField } from './components/CategoryField';
import { CountryField } from './components/CountryField';
import { FormError } from './components/FormError';
import { InvalidFormError } from './components/InvalidFormError';
import { QuestionField } from './components/QuestionField';
import { SubCategoryField } from './components/SubCategoryField';
import { SubmitButton } from './components/SubmitButton';
import { usePetitionReportAbuseForm } from './hooks/usePetitionReportAbuseForm';
import type { FormValues, ReportContext } from './shared/types';
import { resetFormDecorator } from './shared/utils/decorators';

type Props = ReportContext & {
	onSuccess?: () => void;
};

export const PetitionReportAbuseForm: React.FC<Props> = ({ onSuccess, ...reportContext }) => {
	const {
		actions: { submitReport },
	} = usePetitionReportAbuseForm({ reportContext, onSuccess });
	const { type } = reportContext;

	return (
		<Form<FormValues> onSubmit={submitReport} decorators={[resetFormDecorator]} mutators={{ ...valueSetterMutator }}>
			{({ handleSubmit }) => (
				<form onSubmit={handleSubmit} data-qa="abuse-report-form">
					<CategoryField type={type} />
					<div className="mb-8 flex flex-col gap-6">
						<CountryField />
						<SubCategoryField type={type} />
						<QuestionField type={type} />
					</div>
					<InvalidFormError />
					<FormError />
					<div className="w-full lg:flex lg:justify-end">
						<SubmitButton />
					</div>
				</form>
			)}
		</Form>
	);
};
